import { CdcLojaRestService } from './../omni-rest/cdc/cdc-loja-rest.service';
import { FichaListaHomeQueryParams } from './ficha-lista-home/model/ficha-lista-home-query-params.interface';
import { RecoverDataProposal } from './ficha-cadastro/model/recover-data-proposal/recover-data-proposal';

import {
  throwError as observableThrowError,
  of as observableOf,
  Observable,
  of,
} from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpStatus } from '../omni-rest/http-status';
import { OmniMaisRestService } from '../omni-rest/omni-mais/omni-mais-rest.service';
import { OmniMaisV2RestService } from '../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { DadoSimulacao } from './ficha-cadastro/ficha-cadastro-resultado-parcial/model/dado-simulacao';
import { ConfirmaDadosAssinatura } from './ficha-verificacao-seguranca/confirma-dados-assinatura';
import { DadosEnvio } from './ficha-timeline/ficha-timeline-emissao-pre-contrato/model/dados-envio';
import { LeadsOnlineRestService } from '../omni-rest/leads/leads-online-rest.service';
import { FichaListaHomeInterface } from './ficha-lista-home/model/ficha-lista-home.interface';
import { HttpParams } from '@angular/common/http';
import { StatusSignatureByDocument } from './ficha-timeline/timeline-status-signature/model/status-signature.interface';
import { CustomerInformation } from './ficha-timeline/ficha-modal-avalista/model/customer-information';
import { OmniMaisRodasAssinaturaService } from '../omni-rest/omni-mais/omni-mais-rodas-assinatura.service';
import { OmniGeralRestService } from '../omni-rest/omni-geral/omni-geral-rest.service';
import { OmniVerificacaoSegurancaService } from '../omni-rest/omni-verificacao-seguranca/omni-verificacao-seguranca.service';
import { OmniSeguroService } from '../omni-rest/omni-seguro/omni-seguro.service';
import { OmniAssistenciaService } from '../omni-rest/omni-assistencia/omni-assistencia.service';
import { AssistanceTypeResponse } from './ficha-cadastro/ficha-cadastro-resultado-parcial/model/proposta/assistance-types';
import { AllAssistances } from './ficha-cadastro/ficha-cadastro-resultado-parcial/model/proposta/all-assistances';
import { InsuranceGroupsResponse } from './ficha-cadastro/ficha-cadastro-resultado-parcial/model/proposta/insurance-groups';
import { AllInsurances } from './ficha-cadastro/ficha-cadastro-resultado-parcial/model/proposta/all-insurances';
import { VerifyRequiredData } from './ficha-timeline/ficha-timeline-emissao-pre-contrato/model/verify-required-data.interface';

@Injectable()
export class FichaService {
  constructor(
    private readonly restService: OmniMaisRestService,
    private readonly verificacaoRestService: OmniVerificacaoSegurancaService,
    private readonly leadsOnlineRestService: LeadsOnlineRestService,
    private readonly restServiceV2: OmniMaisV2RestService,
    private readonly omniMaisRodasAssinaturaService: OmniMaisRodasAssinaturaService,
    private readonly omniGeralRestService: OmniGeralRestService,
    private readonly cdcLojaRestService: CdcLojaRestService,
    private readonly omniSeguroService: OmniSeguroService,
    private readonly omniAssistenciaService: OmniAssistenciaService,
  ) {}

  // Serviços da Tela Inicial --------------------------------------------------------------------------------------
  findAllEmAnalise(data): Observable<any> {
    return this.restServiceV2.post(
      'proposta/listPropostaPorFaseOperadorV3',
      data,
    );
  }

  findAllAprovada(data): Observable<any> {
    return this.restServiceV2.post(
      'proposta/listPropostaPorFaseOperadorV3',
      data,
    );
  }

  findAllEmFechamento(data): Observable<any> {
    return this.restServiceV2.post(
      'proposta/listPropostaPorFaseOperadorV3',
      data,
    );
  }

  findAllRecusada(data): Observable<any> {
    return this.restServiceV2.post(
      'proposta/listPropostaPorFaseOperadorV3',
      data,
    );
  }

  findAllContratoCancelado(data): Observable<any> {
    return this.restServiceV2.post(
      'proposta/listPropostaPorFaseOperadorV3',
      data,
    );
  }

  analiseAutomatica(idProposta: string): Observable<any> {
    return this.restService.post(`veiculo/analise-automatica/${idProposta}`);
  }
  // Serviços da Tela Inicial --------------------------------------------------------------------------------------

  // Serviços do Cadastro de Nova Ficha ----------------------------------------------------------------------------
  getLojistaByOperador(): Observable<any> {
    return this.restService.get('lojista/listaLojistaOperador');
  }

  getVendedoresByLojista(idLojista): Observable<any> {
    return this.restService.get(`vendedor/listByLojista/${idLojista}`);
  }

  getTipoVeiculo(): Observable<any> {
    return this.restService.get('veiculo/buscarTipoVeiculo');
  }

  getMarcaPorTipo(idTipoVeiculo: string): Observable<any> {
    return this.restService.get(`veiculo/buscarMarcaPorTipo/${idTipoVeiculo}`);
  }

  getAnoModeloPorMarca(
    idTipoVeiculo: string,
    idMarca: string,
  ): Observable<any> {
    return this.restService.get(
      `veiculo/buscarAnoModeloPorMarca/${idTipoVeiculo}/${idMarca}`,
    );
  }

  getModeloPorMarcaAno(
    idTipoVeiculo: string,
    idMarca: string,
    idAnoModelo: string,
  ): Observable<any> {
    return this.restService.get(
      `veiculo/buscarModeloPorMarcaAno/${idTipoVeiculo}/${idMarca}/${idAnoModelo}`,
    );
  }

  getVersaoPorMarcaModeloAno(
    idTipoVeiculo: string,
    idMarca: string,
    idAnoModelo: string,
    idModelo: string,
  ): Observable<any> {
    return this.restService.get(
      `veiculo/buscarVersaoPorMarcaModeloAno/${idTipoVeiculo}/${idMarca}/${idModelo}/${idAnoModelo}`,
    );
  }

  getCotacaoPorVersao(
    idTipoVeiculo: string,
    idMarca: string,
    idAnoModelo: string,
    idModelo: string,
    idVersao: string,
  ): Observable<any> {
    return this.restService.get(
      `veiculo/buscarCotacaoPorVersao/${idTipoVeiculo}/${idMarca}/${idModelo}/${idVersao}/${idAnoModelo}`,
    );
  }

  getAllNacionalidade() {
    return this.restService.get('nacionalidade/list');
  }

  getCidadePorUf(uf: string) {
    return this.restService.get(`cidade/listCidadeByUf/${uf}`);
  }

  getAllProfissoes() {
    return this.restService.get('profissao/list');
  }

  getProfissoesByClasseProfissional(id: number) {
    return this.restService.get(`profissao/listarProfissoesPorClasse/${id}`);
  }

  getEnderecoByCep(cep: string) {
    return this.restService.get(`cep/buscarEnderecoPorCep/${cep}`);
  }

  simular(payload: any) {
    return this.restServiceV2.post('veiculo/simular', payload);
  }

  simulacaoDetalhe(simulacao: DadoSimulacao, parcelas?: number) {
    let url =
      `proposta/${simulacao.getNumeroProposta()}/simulacao/detalhe` +
      `?ultimaDataTaxa=${simulacao.getUltimaDataTaxa()}` +
      `&retorno=${simulacao.getSeguro().getRetorno()}` +
      `&carencia=${simulacao.getCarencia()}` +
      `&entradaPorcentagem=${simulacao.getEntradaPorcentagem()}` +
      `&parcelas=${parcelas || 0}`;

    if (simulacao.getValor() && simulacao.getValor() > 0) {
      url = `${url}&valorLiberado=${simulacao.getValor()}`;
    } else {
      url = `${url}&valorLiberado=0`;
    }

    if (
      simulacao.getSeguro().getGrupoSeguroIds() != null &&
      simulacao.getSeguro().getGrupoSeguroIds().length
    ) {
      simulacao
        .getSeguro()
        .getGrupoSeguroIds()
        .map((elem) => elem.seguroId)
        .forEach((item) => {
          url = `${url}&seguroId=${item}`;
        });
    } else {
      url = `${url}&seguroId=-1`;
    }

    if (
      simulacao
        .getSeguro()
        .getGrupoAssistenciaIds()
        .some((grupoAssistencia) => grupoAssistencia.length > 0)
    ) {
      simulacao
        .getSeguro()
        .getGrupoAssistenciaIds()
        .map((grupoAssistencia) => grupoAssistencia)
        .forEach((grupoAssistencia) => {
          grupoAssistencia.forEach((element) => {
            if (element !== undefined && element !== null) {
              url = `${url}&assistenciaId=${element.assistenciaId}`;
            } else {
              url = `${url}&assistenciaId=-1`;
            }
          });
        });
    } else {
      url = `${url}&assistenciaId=-1`;
    }
    return this.restServiceV2.get(url);
  }

  getDadosProposta(idProposta: string): Observable<any> {
    return this.restServiceV2.get(`proposta/${idProposta}/dados`).pipe(
      catchError((error, source) => {
        if (error.status === HttpStatus.BAD_REQUEST) {
          return observableOf(error.error);
        }
        return observableThrowError(error);
      }),
    );
  }

  getPropostaBySimulacao(idProposta: string) {
    return this.restService.get(`veiculo/simulacao/${idProposta}`).pipe(
      catchError((error, source) => {
        if (error.status === HttpStatus.BAD_REQUEST) {
          return observableOf(error.error);
        }
        return observableThrowError(error);
      }),
    );
  }

  getAllGrupoSeguro(): Observable<InsuranceGroupsResponse> {
    return this.omniSeguroService.get('simulation/insurance-group');
  }

  getAllSeguros(): Observable<AllInsurances> {
    return this.omniSeguroService.get('seguro/find');
  }

  getAllTipoAssistencia(): Observable<AssistanceTypeResponse> {
    return this.omniAssistenciaService.get('assistance-type');
  }

  getAllAssistencias(productType: string): Observable<AllAssistances> {
    const params = new HttpParams().append('productTypes', productType);
    return this.omniAssistenciaService.get('assistance/agent', { params });
  }

  getListaNomeMae(idProposta: string, idCliente: string) {
    return this.restService.get(
      `cliente/listNomeMae/${idProposta}/${idCliente}`,
    );
  }

  getOriginadorLeads() {
    return this.leadsOnlineRestService.get('agent/originator').toPromise();
  }

  finalizarSimulacao(payload: any) {
    return this.restServiceV2.post('veiculo/finalizarSimulacao', payload);
  }

  finalizarSimulacaoLeads(payload: any) {
    return this.leadsOnlineRestService.post(
      'vehicle/finishSimulation',
      payload,
    );
  }

  verificarCpf(cpf: string) {
    return this.restService.get(`cliente/verificar/${cpf}`);
  }

  recuperarDadosFicha(cpf: string, idlojista) {
    return this.restService.get(
      `veiculo/recuperar-dados/${cpf}?lojista=${idlojista}`,
    );
  }
  // Serviços do Cadastro de Nova Ficha ---------------------------------------------------------------------------

  sendSosObservacao(body: any): Observable<any> {
    return this.restService.post('proposta/pushObservacaoSos/', body);
  }

  prosseguirNegociacao(body: any): Observable<any> {
    return this.restService.post('proposta/pushProssegueNegociacao', body);
  }

  sendMotivoDesistencia(body: any): Observable<any> {
    return this.restService.post('proposta/pushMotivoDesistencia', body);
  }

  pushDocumentacaoEnviada(body: any): Observable<any> {
    return this.restService.post('proposta/pushDocumentacaoEnviada', body);
  }

  pushRespostaSos(body: any): Observable<any> {
    return this.restService.post('proposta/pushRespostaSos', body);
  }

  pushAvalista(body: any): Observable<any> {
    return this.restService.post('proposta/pushAvalista', body);
  }

  // Serviços de Assinatura de Documentos ------------------------------------------------------------------------

  getDataSign(idProposta: string): Observable<any> {
    return this.omniMaisRodasAssinaturaService.get(
      `signature/${idProposta}/data`,
    );
  }

  generatePreContract(dadosEnvio: DadosEnvio): Observable<any> {
    return this.restServiceV2.post('pre-contract/generate', dadosEnvio);
  }

  resendSign(obj): Observable<any> {
    return this.omniMaisRodasAssinaturaService.post('signature/link/resend', {
      idProposta: obj.propostaId,
      tipoComunicacao: obj.tpComunicacao,
    });
  }

  getSignStatus(idProposta: number): Observable<StatusSignatureByDocument> {
    return this.omniMaisRodasAssinaturaService.get(
      `signature/check-status/${idProposta}`,
    );
  }

  confirmContactDetails(
    dadosAssinatura: ConfirmaDadosAssinatura,
  ): Observable<any> {
    return this.verificacaoRestService.post(
      'cliente/confirmar-dados-contato',
      dadosAssinatura,
    );
  }

  getAllProposalByPhaseIdAndProduct(
    queryParams: FichaListaHomeQueryParams,
  ): Observable<FichaListaHomeInterface> {
    let params = new HttpParams();
    params = this.setParams(queryParams, params);
    return this.restServiceV2.get('proposals', { params });
  }

  private setParams(
    queryParams: FichaListaHomeQueryParams,
    params: HttpParams,
  ) {
    let para = params;

    if (queryParams) {
      Object.keys(queryParams).forEach((key) => {
        if (queryParams[key] !== undefined && queryParams[key] !== null) {
          if (Array.isArray(queryParams[key])) {
            queryParams[key].forEach((element) => {
              para = para.append(key, element);
            });
          } else {
            para = para.append(key, String(queryParams[key]));
          }
        }
      });
    }

    return para;
  }

  getShowNewHome() {
    return this.restServiceV2.get('proposals/show');
  }

  putRecoverFullDataProposal(body: any): Observable<RecoverDataProposal> {
    return body && body.proposal.id
      ? this.restServiceV2.put('proposals', { ...body })
      : of({} as RecoverDataProposal);
  }

  getRecoverFullDataProposal(
    idProposal: number,
  ): Observable<RecoverDataProposal> {
    return this.restServiceV2.get(`proposals/${idProposal}`);
  }

  getItensPaginaHome(): Observable<{ key: string; value: string }> {
    return this.omniGeralRestService.get('parametro/24/NR_ITENS_PAGINA_HOME');
  }

  getCustomerInformation(
    idProposta: number
  ): Observable<CustomerInformation[]> {
    return this.restServiceV2.get(`proposta/${idProposta}/phones`);
  }

  verifyCellPhone(
    ddd: string,
    numero: string,
    validaProposta: boolean = true,
  ): Observable<{ status: string; messages?: string[] }> {
    return this.omniGeralRestService.post('telefone/validar', {
      ddd,
      numero,
      validaProposta,
    });
  }

  verifyEmail(
    email: string,
    validaProposta: boolean = true,
  ): Observable<{ status: string; messages?: string[] }> {
    return this.omniGeralRestService.post('email/validar', {
      email,
      validaProposta,
    });
  }

  verifyRequiredSignatureData(
    idProposta: number,
  ): Observable<VerifyRequiredData> {
    return this.omniMaisRodasAssinaturaService.get(
      `signature/e-signature/validate/proposal/${idProposta}`,
    );
  }
}
